import styled from 'styled-components'
import { ErrorMessage } from '@sketch/components'

import { ReactComponent as ExclamationMarkIcon } from '@sketch/icons/exclamation-mark-triangle-24-svg'

export const BaseCommentTabMessageError = styled(ErrorMessage)`
  padding: 16px;
`

export const ErrorIcon = styled(ExclamationMarkIcon)`
  opacity: 0.55;
`
